export type Palette5 = {
  deep: string;
  shadow: string;
  base: string;
  light: string;
  rim: string;
};

export function shade(hex: string, percent: number): string {
  const n = parseInt(hex.slice(1), 16);
  const r = Math.max(0, Math.min(255, ((n >> 16) & 0xff) + percent));
  const g = Math.max(0, Math.min(255, ((n >> 8) & 0xff) + percent));
  const b = Math.max(0, Math.min(255, (n & 0xff) + percent));
  return '#' + ((r << 16) | (g << 8) | b).toString(16).padStart(6, '0');
}

export function palette5(base: string): Palette5 {
  return {
    deep: shade(base, -96),
    shadow: shade(base, -48),
    base,
    light: shade(base, 32),
    rim: shade(base, 64),
  };
}
